import React, { useState, useEffect } from 'react';
import PositionsListOverlay from '../../../UserComponents/modals/PositionsList.js';
import ErrorOverlay from '../../../UserComponents/overlays/ErrorOverlay.js';
import { createPlayer } from '../../../services/player.services';
import { isValidEmail } from '../../../utils/helper';
import { useSelector } from 'react-redux';
import './CreatePlayerModal.css';

const initialState = {
  teamId: '',
  firstName: '',
  lastName: '',
  email: '',
  homeJersey: '',
  awayJersey: '',
  position1: '',
  position2: '',
  height: '',
  weight: '',
  grade: '',
  phone: '',
  isCaptain: false,
};

const CreatePlayerOverlay = ({ isVisible, onClose, tid, handleGetPlayers }) => {
  const user = useSelector((state) => state.auth.user);
  
  const [initialStateForm, setInitialStateForm] = useState(initialState);
  const [displayPhone, setDisplayPhone] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const [pos1Visible, setPos1Visible] = useState(false);
  const [pos2Visible, setPos2Visible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const togglePosition1 = () => setPos1Visible(!pos1Visible);
  const togglePosition2 = () => setPos2Visible(!pos2Visible);

  const handleFormChange = (name, value) => {
    setInitialStateForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (!isVisible) {
      setInitialStateForm(initialState);
    } else {
      handleFormChange('teamId', tid);
    }
  }, [isVisible, tid]);

  useEffect(() => {
    const phoneLength = initialStateForm.phone.length;
    let formattedNumber = '';

    if (phoneLength < 4) {
      formattedNumber = initialStateForm.phone;
    } else if (phoneLength >= 4 && phoneLength < 7) {
      formattedNumber = `(${initialStateForm.phone.slice(0, 3)}) ${initialStateForm.phone.slice(3)}`;
    } else {
      formattedNumber = `(${initialStateForm.phone.slice(0, 3)}) ${initialStateForm.phone.slice(3, 6)}-${initialStateForm.phone.slice(6)}`;
    }

    setDisplayPhone(formattedNumber);
  }, [initialStateForm.phone]);

  const handleCreate = async () => {
    try {
      if (initialStateForm.email && !isValidEmail(initialStateForm.email)) {
        throw new Error('Invalid email format!');
      }

      setLoading(true);
      await createPlayer(initialStateForm, user?.token);
      await handleGetPlayers();
      setInitialStateForm({ ...initialState, teamId: initialStateForm.teamId });
      onClose();
    } catch (e) {
      setError(e);
      console.log('ERROR in CreatingPlayer =>>>>>>>>>>>> ', e.response?.data.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={`modal ${isVisible ? 'show' : ''}`}>
      
      {error && (
        <ErrorOverlay
          onClose={() => setError(null)}
          visible={!!error}
          error={error}
        />
      )}
      <div className="modal-content">
        <div className="modal-header">
          <h2>ADD A PLAYER</h2>

        </div>
        <div className="modal-body">
        
          <label className="checkbox-container">
          
            Captain
            <input
              type="checkbox"
              checked={initialStateForm.isCaptain}
              onChange={() => handleFormChange('isCaptain', !initialStateForm.isCaptain)}
            />
           
          </label>
          <span className="modalTitle">First Name: </span>
          <input
            type="text"
            // placeholder="First Name"
            value={initialStateForm.firstName}
            onChange={(e) => handleFormChange('firstName', e.target.value)}
            className="input-field"
          />
           <span className="modalTitle">Last Name: </span>
          <input
            type="text"
            // placeholder="Last Name"
            value={initialStateForm.lastName}
            onChange={(e) => handleFormChange('lastName', e.target.value)}
            className="input-field"
          />
           <span className="modalTitle">Home Jersey #: </span>
          <input
            type="number"
            // placeholder="Home Jersey #"
            value={initialStateForm.homeJersey}
            onChange={(e) => handleFormChange('homeJersey', e.target.value)}
            className="input-field"
          />
           <span className="modalTitle">Away Jersey #: </span>
          <input
            type="number"
            // placeholder="Away Jersey #"
            value={initialStateForm.awayJersey}
            onChange={(e) => handleFormChange('awayJersey', e.target.value)}
            className="input-field"
          />
           <span className="modalTitle">Position 1: </span>
          <input
            type="text"
            // placeholder="Position 1"
            value={initialStateForm.position1}
            onClick={togglePosition1}
            className="input-field"
            readOnly
          />
           <span className="modalTitle">Position 2: </span>
          <input
            type="text"
            // placeholder="Position 2"
            value={initialStateForm.position2}
            onClick={togglePosition2}
            className="input-field"
            readOnly
          />
           <span className="modalTitle">Height: </span>
          <input
            type="text"
            // placeholder="Height"
            value={initialStateForm.height}
            onChange={(e) => handleFormChange('height', e.target.value)}
            className="input-field"
          />
           <span className="modalTitle">Weight: </span>
          <input
            type="text"
            // placeholder="Weight"
            value={initialStateForm.weight}
            onChange={(e) => handleFormChange('weight', e.target.value)}
            className="input-field"
          />
           <span className="modalTitle">Grade: </span>
          <input
            type="text"
            // placeholder="Grade"
            value={initialStateForm.grade}
            onChange={(e) => handleFormChange('grade', e.target.value)}
            className="input-field"
          />
          {/* <span className="modalTitle">Phone: </span>
          <div className="input-with-icon">
          
            <input
              type="text"
              placeholder="Phone"
              value={isFocused ? initialStateForm.phone : displayPhone}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              onChange={(e) => handleFormChange('phone', e.target.value)}
              className="input-field"
            /> */}
            {/* <span className="icon"><Phone /></span> */}
            
          {/* </div>
          <span className="modalTitle">Email: </span>
          <div className="input-with-icon">
          
            <input
              type="email"
              placeholder="Email"
              value={initialStateForm.email}
              onChange={(e) => handleFormChange('email', e.target.value)}
              className="input-field"
            /> */}
            {/* <span className="icon"><Mail /></span> */}
          {/* </div> */}
        </div>
        <div className="modal-footer">
          <button onClick={onClose} className="btn-secondary">Cancel</button>
          <button onClick={handleCreate} className="btn-primary">
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>

      <PositionsListOverlay
        onBackdropClick={() => togglePosition1()}
        setPosition={(text) =>
          setInitialStateForm((prev) => ({ ...prev, position1: text }))
        }
        visible={pos1Visible}
      />
      <PositionsListOverlay
      
        onBackdropClick={() => togglePosition2()}
        setPosition={(text) =>
          setInitialStateForm((prev) => ({ ...prev, position2: text }))
        }
        visible={pos2Visible}
      />
    </div>
  );
};

export default CreatePlayerOverlay;
